export function SkeletonRainfallTable() {
  const columnWidths = ['30%', '15%', '15%', '15%', '15%'];

  return (
    <div className="table-responsive mt-4">
      <span
        className="skeleton-shimmer rounded"
        style={{
          display: 'block',
          width: '45%',
          height: 31,
          marginLeft: '8px',
          marginBottom: '6px',
        }}
      />
      <table className="table align-middle">
        <thead>
          <tr>
            {columnWidths.map((width, i) => (
              <th key={i} style={{ width }}>
                <span
                  className="skeleton-shimmer rounded"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: 34,
                  }}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 5 }).map((_, r) => (
            <tr key={r}>
              {columnWidths.map((width, c) => (
                <td key={c} style={{ width }}>
                  <span
                    className="skeleton-shimmer rounded"
                    style={{
                      display: 'block',
                      width: '100%',
                      height: 35,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
